import React from "react";
import { Col, Pane, Row } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import NavComponent from "../../components/NavComponent";
import { OutputsReportList } from "../../components/outputs/OutputsReportList";
import { OutputsReportForm } from "../../components/outputs/OutputsReportForm";
import { useSelectedReport } from "../../hooks/useSelectedReport";
var OutputsPage = function () {
    var formatMessage = useIntl().formatMessage;
    var _a = useSelectedReport(), selectedReportKey = _a.selectedReportKey, setSelectedReport = _a.setSelectedReport;
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                id: "ui-br-agency.pane.title.navigation",
            }) },
            React.createElement(NavComponent, null)),
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.title" }) },
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, md: 3 },
                    React.createElement(OutputsReportList, { selectedReport: selectedReportKey, onSelectReport: setSelectedReport })),
                React.createElement(Col, { xs: 12, mdOffset: 1, md: 8 }, selectedReportKey ? (React.createElement(OutputsReportForm, null)) : (React.createElement(FormattedMessage, { id: "ui-br-agency.outputs.noSelectedReport" })))))));
};
export default OutputsPage;
